"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactLoadScript = _interopRequireDefault(require("react-load-script"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var PlaidLink = /*#__PURE__*/function (_Component) {
  _inherits(PlaidLink, _Component);

  var _super = _createSuper(PlaidLink);

  function PlaidLink(props) {
    var _this;

    _classCallCheck(this, PlaidLink);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _this.state = {
      disabledButton: true,
      linkLoaded: false,
      scriptLoaded: false,
      initializeURL: 'https://cdn.plaid.com/link/v2/stable/link-initialize.js'
    };
    _this.onScriptError = _this.onScriptError.bind(_assertThisInitialized(_this));
    _this.onScriptLoaded = _this.onScriptLoaded.bind(_assertThisInitialized(_this));
    _this.handleLinkOnLoad = _this.handleLinkOnLoad.bind(_assertThisInitialized(_this));
    _this.handleOnClick = _this.handleOnClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PlaidLink, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "onScriptError",
    value: function onScriptError() {
      console.error('There was an issue loading the link-initialize.js script');
    }
  }, {
    key: "onScriptLoaded",
    value: function onScriptLoaded() {
      window[this.props.handlerName] = window.Plaid.create({
        apiVersion: this.props.apiVersion,
        clientName: this.props.clientName,
        env: this.props.env,
        key: this.props.publicKey,
        onExit: this.props.onExit,
        onLoad: this.handleLinkOnLoad,
        onEvent: this.props.onEvent,
        onSuccess: this.props.onSuccess,
        product: this.props.product,
        token: this.props.token,
        webhook: this.props.webhook,
        receivedRedirectUri: this.props.receivedRedirectUri
      });
      this.setState({
        disabledButton: false,
        scriptLoaded: true
      });
    }
  }, {
    key: "handleLinkOnLoad",
    value: function handleLinkOnLoad() {
      if (this.props.onLoad != null) {
        this.props.onLoad();
      }

      if (this._isMounted) {
        this.setState({
          linkLoaded: true
        });
      }

      if (this.props.receivedRedirectUri) {
        this.openLink();
      }
    }
  }, {
    key: "handleOnClick",
    value: function handleOnClick(event) {
      if (this.props.onClick != null) {
        this.props.onClick(event, this.openLink.bind(this));
      } else {
        this.openLink();
      }
    }
  }, {
    key: "openLink",
    value: function openLink() {
      var institution = this.props.institution || null;

      if (window[this.props.handlerName]) {
        try {
          window[this.props.handlerName].open(institution);
        } catch (err) {
          if (this.props.onError) {
            this.props.onError(err);
          } else {
            console.error(err);
          }
        }
      }
    }
  }, {
    key: "exit",
    value: function exit(configurationObject) {
      if (window[this.props.handlerName]) {
        window[this.props.handlerName].exit(configurationObject);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window[this.props.handlerName] = null;
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !this.props.receivedRedirectUri && /*#__PURE__*/_react["default"].createElement("button", {
        "data-test-id": "link-bank",
        onClick: this.handleOnClick,
        disabled: this.state.disabledButton || this.props.disabled,
        className: this.props.className
      }, this.props.children), /*#__PURE__*/_react["default"].createElement(_reactLoadScript["default"], {
        url: this.state.initializeURL,
        onError: this.onScriptError,
        onLoad: this.onScriptLoaded
      }));
    }
  }]);

  return PlaidLink;
}(_react.Component);

_defineProperty(PlaidLink, "defaultProps", {
  apiVersion: 'v2',
  env: 'sandbox',
  institution: null,
  token: null,
  handlerName: 'linkHandler'
});

_defineProperty(PlaidLink, "propTypes", {
  // ApiVersion flag to use new version of Plaid API
  apiVersion: _propTypes["default"].string,
  // Displayed once a user has successfully linked their account
  clientName: _propTypes["default"].string.isRequired,
  // The Plaid API environment on which to create user accounts.
  // For development and testing, use tartan. For production, use production
  env: _propTypes["default"].oneOf(['tartan', 'sandbox', 'development', 'production']).isRequired,
  // Open link to a specific institution, for a more custom solution
  institution: _propTypes["default"].string,
  // The public_key associated with your account; available from
  // the Plaid dashboard (https://dashboard.plaid.com)
  publicKey: _propTypes["default"].string,
  // The Plaid products you wish to use, an array containing some of connect,
  // auth, identity, income, transactions, assets
  product: _propTypes["default"].arrayOf(_propTypes["default"].oneOf(['connect', 'info', 'auth', 'identity', 'income', 'transactions', 'assets'])),
  // Specify an existing user's public token to launch Link in update mode.
  // This will cause Link to open directly to the authentication step for
  // that user's institution.
  token: _propTypes["default"].string,
  // Specify a webhook to associate with a user.
  webhook: _propTypes["default"].string,
  // A function that is called when a user has successfully onboarded their
  // account. The function should expect two arguments, the public_key and a
  // metadata object
  onSuccess: _propTypes["default"].func.isRequired,
  // A function that is called when a user has specifically exited Link flow
  onExit: _propTypes["default"].func,
  // A function that is called when the Link module has finished loading.
  // Calls to plaidLinkHandler.open() prior to the onLoad callback will be
  // delayed until the module is fully loaded.
  onLoad: _propTypes["default"].func,
  // A function that is called during a user's flow in Link.
  onEvent: _propTypes["default"].func,
  // Button Class names as a String
  className: _propTypes["default"].string,
  // Link handler name to be possible to use several links on one page
  handlerName: _propTypes["default"].string,
  // OAuth redirect URI
  receivedRedirectUri: _propTypes["default"].string,
  // Plaid internal error
  onError: _propTypes["default"].func
});

var _default = PlaidLink;
exports["default"] = _default;